import { CommonModule, DecimalPipe, NgClass } from '@angular/common';
import { Component, inject, input, output, signal } from '@angular/core';
import { RouterModule } from '@angular/router';
import { UiModule } from '@components/ui/ui-module';
import { Binder, UserBinder } from '@models/binder.model';
import { BinderService } from '@services/binder.service';
import { Router } from '@services/route.service';
import { ScannerService } from '@services/scanner.service';
import { User } from '@services/user.service';

@Component({
  selector: 'lgb-hero-binder',
  imports: [
    CommonModule,
    RouterModule,
    NgClass,
    UiModule,
    DecimalPipe
  ],
  templateUrl: './hero-binder.html',
  styleUrl: './hero-binder.css',
})
export class HeroBinder {
  //services
  readonly router=inject(Router);
  readonly binderS=inject(BinderService);
  readonly user=inject(User);
  readonly scanService=inject(ScannerService);

  //input
  readonly admin=input(true);
  readonly route=input<string>(null);
  readonly routeParams=input<string[]>([]);
  readonly fullWidth=input(false);
  readonly cardDisplay=input(false);
  readonly back=input<string>(null);
  readonly uBinder=input.required<UserBinder>();
  readonly binder=input.required<Binder | null>();    //binder associé au user binder => peut être null si ce n'est pas un binder Plateau-Indigo
  readonly unlike=output<boolean>();

  goTo(){
    if(this.route() && this.admin())
      this.router.navigate(this.route(), this.routeParams());
  }

  getBinderImg(){
    let img: string=null;
    if(this.binder())
      img=this.binder().img;
    return [this.binderS.getImg(img)];
  }

  setScan(event: Event){
    event.preventDefault();
    event.stopPropagation();
    this.scanService.enable('binder', this.uBinder().ident);
  }

  toggleFavoriteBinder(){
    /*event.preventDefault();
    event.stopPropagation();*/
    this.binderS.toggleFavoriteBinder(this.uBinder().ident)
      .subscribe(uBinder => {
        this.uBinder().isFavorite=uBinder.isFavorite;

        if(!uBinder.isFavorite)
          this.unlike.emit(true);
      });
  }
}
